import { useEffect, useState } from "react";
import {
  messagesAdd,
  metaMessageTemplates,
} from "../../api/Messages";

import { LoadingDiv, SweetAlertShow } from "../master/Master";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { useNavigate } from "react-router-dom";
import { messageSlugs, previewValues } from "./PreviewValues";

export default function MessagesAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [templates, setTemplates] = useState([]);
  const [bodyVariables, setBodyVariables] = useState([]);
  const [templateBody, setTemplateBody] = useState("");

  const variableOptions = Object.keys(previewValues);

  const getMessageTemplates = async () => {
    try {
      setLoading(true);
      const response = await metaMessageTemplates();
      if (response?.data?.data) {
        setTemplates(response.data.data);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMessageTemplates();
  }, []);
  useEffect(() => {
    handleTemplateChange();
  }, [data?.meta_template_name, templates]);

  const handleTemplateChange = () => {
    const templateName = data?.meta_template_name;
    const template = templates.find((t) => t.name === templateName);
    const bodyComponent = template?.components?.find((c) => c.type === "BODY");
    const bodyText = bodyComponent?.text || "";
    setTemplateBody(bodyText);

    const matches = bodyText.match(/{{\d+}}/g) || [];
    const count = matches.length;
    const variables = [];
    for (let i = 1; i <= count; i++) {
      variables.push({
        key: i,
        value: "",
      });
    }

    setBodyVariables(variables);
  };

  const getPreviewMessage = () => {
    let message = templateBody;
    bodyVariables.forEach((item) => {
      const value = previewValues[item.value] || `{{${item.key}}}`;
      message = message.replaceAll(`{{${item.key}}}`, value);
    });

    return message;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const mappedVariables = {};
      bodyVariables.forEach((item) => {
        mappedVariables[item.key] = item.value;
      });
      const formData = new FormData();
      formData.append("slug", data.slug);
      formData.append("name", data.name);
      formData.append(
        "push_notification_status",
        data.push_notification_status,
      );
      formData.append(
        "push_notification_header",
        data.push_notification_header,
      );
      formData.append(
        "push_notification_message",
        data.push_notification_message,
      );
      formData.append("meta_whatsapp_status", data.meta_whatsapp_status);
      formData.append("meta_template_name", data.meta_template_name);
      formData.append(
        "meta_message_variables",
        JSON.stringify(mappedVariables),
      );
      const response = await messagesAdd(formData);
      if (response?.data?.status) {
        navigate("/message/list");
        SweetAlertShow("success", "Success", response.data.message);
      } else {
        SweetAlertShow("warning", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const [copiedKey, setCopiedKey] = useState("");

  const copyKey = (key, e) => {
    e.stopPropagation();

    navigator.clipboard.writeText(key);

    setCopiedKey(key);

    setTimeout(() => {
      setCopiedKey("");
    }, 1500);
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    <div className="row">
                      <div className="col-6">
                        <div className="card">
                          <div className="card-header">
                            <h5>Message Template</h5>
                          </div>

                          <div className="card-body">
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="mb-3 col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      name="slug"
                                      id="slug"
                                      className="form-select"
                                      required
                                      value={data?.slug}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          slug: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" selected disabled>
                                        Select Slug
                                      </option>
                                      {messageSlugs?.map((slug) => (
                                        <option key={slug} value={slug}>
                                          {slug}
                                        </option>
                                      ))}
                                    </select>
                                    <label>Slug</label>
                                  </div>
                                </div>

                                <div className="mb-3 col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      name="name"
                                      id="name"
                                      required
                                      placeholder="Name"
                                      className="form-control"
                                      value={data?.name}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                    <label>Name</label>
                                  </div>
                                </div>
                                <div className="mb-3 col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      name="push_notification_status"
                                      id="push_notification_status"
                                      className="form-select"
                                      required
                                      value={data?.push_notification_status}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          push_notification_status:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" selected disabled>
                                        Push Notification Status
                                      </option>
                                      <option value="1">ON</option>
                                      <option value="2">OFF</option>
                                    </select>
                                    <label> Push Notification Status</label>
                                  </div>
                                </div>

                                {data?.push_notification_status === "1" && (
                                  <>
                                    <div className="mb-3 col-md-6">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="text"
                                          name="push_notification_header"
                                          id="push_notification_header"
                                          required
                                          placeholder="Push Notification Header"
                                          className="form-control"
                                          value={data?.push_notification_header}
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              push_notification_header:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label>
                                          Push Notification Header/Title
                                        </label>
                                      </div>
                                    </div>
                                    <div className="mb-3 col-md-6">
                                      <div className="form-floating form-floating-outline">
                                        <textarea
                                          type="text"
                                          name="push_notification_message"
                                          id="push_notification_message"
                                          placeholder="Message"
                                          className="form-control"
                                          required
                                          value={
                                            data?.push_notification_message
                                          }
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              push_notification_message:
                                                e.target.value,
                                            })
                                          }
                                        />
                                        <label>Message</label>
                                      </div>
                                    </div>
                                  </>
                                )}

                                <div className="mb-3 col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      name="meta_whatsapp_status"
                                      id="meta_whatsapp_status"
                                      className="form-select"
                                      required
                                      value={data?.meta_whatsapp_status}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          meta_whatsapp_status: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" selected disabled>
                                        Meta Message Status
                                      </option>
                                      <option value="1">ON</option>
                                      <option value="2">OFF</option>
                                    </select>
                                    <label> Meta Message Status</label>
                                  </div>
                                </div>
                                {data?.meta_whatsapp_status === "1" && (
                                  <>
                                    <div className="mb-3 col-md-6">
                                      <div className="form-floating form-floating-outline">
                                        <select
                                          className="form-select"
                                          value={data?.meta_template_name}
                                          required
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              meta_template_name:
                                                e.target.value,
                                            });
                                          }}
                                        >
                                          <option value="">
                                            Select Template
                                          </option>

                                          {templates.map((item) => (
                                            <option
                                              key={item.name}
                                              value={item.name}
                                            >
                                              {item.name}
                                            </option>
                                          ))}
                                        </select>
                                        <label>Template</label>
                                      </div>
                                    </div>

                                    {bodyVariables.map((variable, index) => (
                                      <div
                                        className="mb-3 col-md-6"
                                        key={index}
                                      >
                                        <div className="form-floating form-floating-outline">
                                          <select
                                            className="form-select"
                                            value={variable.value}
                                            onChange={(e) => {
                                              const temp = [...bodyVariables];

                                              temp[index].value =
                                                e.target.value;

                                              setBodyVariables(temp);
                                            }}
                                          >
                                            <option value="">
                                              Select Variable
                                            </option>

                                            {variableOptions.map((item) => (
                                              <option key={item} value={item}>
                                                {item}
                                              </option>
                                            ))}
                                          </select>
                                          <label>
                                            {"{{"}
                                            {variable.key}
                                            {"}}"}
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}

                                <div className="col-12 text-end">
                                  <button
                                    type="submit"
                                    className="btn btn-primary px-12"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-12">
                                <h5 className="mb-1 border-bottom">
                                  Preview : <code>{data?.slug}</code>{" "}
                                </h5>
                              </div>
                              {data?.push_notification_status === "1" && (
                                <div className="col-12 mb-3">
                                  <h6 className="m-0">
                                    Push Notification Message
                                  </h6>
                                  <div
                                    className="border rounded-3 border-dark p-4 text-dark"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      textAlign: "justify",
                                    }}
                                  >
                                    <b className="d-block">
                                      {data?.push_notification_header}
                                    </b>
                                    <span>
                                      {data?.push_notification_message}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {data?.meta_whatsapp_status === "1" && (
                                <div className="col-12">
                                  <h6 className="m-0">Meta Message</h6>
                                  <div
                                    className="border rounded-3 border-dark p-4 text-dark"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      textAlign: "justify",
                                    }}
                                  >
                                    {getPreviewMessage()}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div className="card">
                          <div className="card-body">
                            <h6 className="mb-1 border-bottom">
                              Preview Values
                            </h6>
                            {Object.entries(previewValues).map(
                              ([key, value]) => (
                                <small
                                  key={key}
                                  className="d-block text-nowrap text-truncate"
                                  title={value}
                                >
                                  <code
                                    className="text-primary cursor-pointer"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => copyKey(key, e)}
                                  >
                                    {key}
                                  </code>{" "}
                                  : {value}
                                  {copiedKey === key && (
                                    <span className="badge bg-label-success ms-2 shadow-sm d-block ">
                                      ✓ Copied
                                    </span>
                                  )}
                                </small>
                              ),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
